var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-table',{attrs:{"id":"cheltable"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('th',{staticClass:"text-h4",staticStyle:{"width":"400px"}},[_vm._v(" Production of Mg-/Co-chelatases ")]),_c('th',{staticClass:"text-h4"},[_vm._v("Possible Genotype(s)")])]),_c('tbody',[_c('tr',{key:"0"},[_c('td',[_c('v-img',{attrs:{"position":"left","height":130,"contain":"","src":require('@/assets/images/chelTable0.png')}})],1),_c('td',[_c('router-link',{attrs:{"to":{
							name: 'OrganismsList',
							query: {
								filters: JSON.stringify({
									genesToFilterProp: {
										values: [
											'1xchlH',
											'1xchlD',
											'1xchlI' ],
										type: 'exact',
									},
									phylumsToFilterProp: [
										'Proteobacteria' ],
								}),
							},
						},"target":"_blank"}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Proteobacteria: chlH, chlD, chl ")])]),_c('p',[_vm._v("Mg-chelatase: (Gibson et al. 1995)")])],1)]),_c('tr',{key:"1"},[_c('td',[_c('v-img',{attrs:{"position":"left","height":130,"contain":"","src":require('@/assets/images/chelTable1.png')}})],1),_c('td',[_c('router-link',{attrs:{"to":{
							name: 'OrganismsList',
							query: {
								filters: JSON.stringify({
									genesToFilterProp: {
										values: [
											'1xcobN',
											'1xcobT',
											'1xcobS',
											'1xchlH',
											'1xchlD',
											'1xchlI' ],
										type: 'exact',
									},
									phylumsToFilterProp: [
										'Proteobacteria' ],
								}),
							},
						},"target":"_blank"}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Proteobacteria: cobN, cobT, cobS, chlH, chlD, chlI ")])]),_c('p',[_vm._v(" Mg-chelatase: (Gibson et al. 1995)"),_c('br'),_vm._v(" Co-chelatase: (Debussche et al. 1992) ")])],1)]),_c('tr',{key:"2"},[_c('td',[_c('v-img',{attrs:{"position":"left","height":130,"contain":"","src":require('@/assets/images/chelTable2.png')}})],1),_c('td',[_c('p',{staticClass:"font-weight-bold"},[_c('router-link',{attrs:{"to":{
								name: 'OrganismsList',
								query: {
									filters: JSON.stringify({
										genesToFilterProp: {
											values: [
												'1xcobN',
												'1xchlH',
												'1xchlD',
												'1xchlI' ],
											type: 'exact',
										},
										phylumsToFilterProp: [
											'Cyanobacteria' ],
									}),
								},
							},"target":"_blank"}},[_vm._v(" Cyanobacteria: cobN, chlH, chlD, chlI ")]),_c('br'),_c('router-link',{attrs:{"to":{
								name: 'OrganismsList',
								query: {
									filters: JSON.stringify({
										genesToFilterProp: {
											values: [
												'1xcobN',
												'2xchlH',
												'1xchlD',
												'1xchlI' ],
											type: 'exact',
										},
										phylumsToFilterProp: [
											'Cyanobacteria' ],
									}),
								},
							},"target":"_blank"}},[_vm._v(" Cyanobacteria: cobN, 2xchlH, chlD, chlI ")])],1),_c('p',[_vm._v(" Mg-chelatase: (Gibson et al. 1995)"),_c('br'),_vm._v("Co-chelatase: (Rodionov et al. 2003) ")])])]),_c('tr',{key:"3"},[_c('td',[_c('v-img',{attrs:{"position":"left","height":130,"contain":"","src":require('@/assets/images/chelTable3.png')}})],1),_c('td',[_c('router-link',{attrs:{"to":{
							name: 'OrganismsList',
							query: {
								filters: JSON.stringify({
									genesToFilterProp: {
										values: [
											'1xcobN',
											'1xchlD',
											'1xchlI' ],
										type: 'exact',
									},
									phylumsToFilterProp: [
										'Actinobacteria' ],
								}),
							},
						},"target":"_blank"}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" Actinobacteria: cobN, chlD, chlI ")])]),_c('p',[_vm._v("Co-chelatase: (Rodionov et al. 2003)")])],1)]),_c('tr',{key:"4"},[_c('td',[_c('v-img',{attrs:{"position":"left","height":130,"contain":"","src":require('@/assets/images/chelTable4.png')}})],1),_c('td',[_c('p',{staticClass:"font-weight-bold"},[_c('router-link',{attrs:{"to":{
							name: 'OrganismsList',
							query: {
								filters: JSON.stringify({
									genesToFilterProp: {
										values: [
											'1xcobN', '1xfs-chlD' ],
										type: 'exact',
									},
									phylumsToFilterProp: [
										'Proteobacteria' ],
								}),
							},
						},"target":"_blank"}},[_vm._v(" Proteobacteria: cobN, fs-chlD ")]),_c('br'),_c('router-link',{attrs:{"to":{
							name: 'OrganismsList',
							query: {
								filters: JSON.stringify({
									genesToFilterProp: {
										values: [
											'1xcobN', '1xfs-chlD' ],
										type: 'exact',
									},
									phylumsToFilterProp: [
										'Actinobacteria' ],
								}),
							},
						},"target":"_blank"}},[_vm._v(" Actinobacteria: cobN, fs-chlD ")]),_c('br'),_c('router-link',{attrs:{"to":{
							name: 'OrganismsList',
							query: {
								filters: JSON.stringify({
									genesToFilterProp: {
										values: [
											'1xcobN', '1xfs-chlD' ],
										type: 'exact',
									},
									kingdomsToFilterProp: [
										'Archaea' ],
								}),
							},
						},"target":"_blank"}},[_vm._v(" Archaea: cobN, fs-chlD ")])],1),_c('p',[_vm._v("Co-chelatase: (Antonov 2020)")])])])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }